// Custom logic, mainly used for Locksmith app features and site navigation
// Everything starts at the DOMReady function at the bottom

// HTML to add info to collections all page depending on selected Locksmith Passcode
const deliveryVerbiage = `<div class="collections-info-text">
    <div>
        <p>Handmade ready-to-cook meals delivered to your door.  (Message can be included when sending gifts).  We ship to Minnesota, Wisconsin, Iowa, North Dakota and South Dakota.  $40 shipping for orders of $100 - $225 ($225 is maximum order, can place multiple orders).  Orders are shipped out Monday through Thursday at 3pm and typically arrive within 1-2 days after shipment.  Orders placed after 3pm on Thursday will be shipped out the following Monday.</p>
    </div>
    <div>
        <p>Click <a href="mailto: thedish@letsdish.com">here</a> to contact us with any questions.</p>
    </div>
</div>`;

const appleValleyVerbiage = `<div class="collections-info-text">
    <div>
        <p>15052 Gleason Path #103A<br>(952) 997-2380</p>
    </div>
</div>`;

const edenPrairieVerbiage = `<div class="collections-info-text">
    <div>
        <p>WE'VE MOVED! 16364 Wagner Way<br>(952) 208-2163</p>
    </div>
</div>`;

const mapleGroveVerbiage = `<div class="collections-info-text">
    <div>
        <p>12187 Elm Creek Blvd.<br>(763) 425-9383</p>
    </div>
</div>`;

const priorLakeVerbiage = `<div class="collections-info-text">
    <div>
        <p>6880 Boudin St NE, #220<br>(952) 226-3663</p>
    </div>
</div>`;

const woodburyVerbiage = `<div class="collections-info-text">
    <div>
        <p>10150 Hudson Road, Suite 110<br>(651) 730-6600</p>
    </div>
</div>`;

const delay = ms => new Promise(res => setTimeout(res, ms));

const aboutUsPage = () => {
    try {
        if (document.location.href.includes('about-us') || document.location.href.includes('/pages/contact-us')) {
            $('#PageContainer').addClass('about-us-page');
        }
    } catch (err) {
        console.error('error caught in aboutUsPage() in custom.js, err: ', err);
    }
}

const navigationLogic = () => {
    try {
        $('#HeaderWrapper .site-nav .site-nav__item:first-child .site-nav__dropdown-list li a').each(function (i) {
            const storeText = $(this).text();

            $(this).replaceWith(`<span class="site-nav__dropdown-link site-nav__dropdown-link--second-level store-select">${storeText}</span>`);
        });

        $('#MobileNav .slide-nav__dropdown[data-parent="tier-2-store-pickup1"] li a').each(function (i) {
            const storeText = $(this).find('span').text();

            if (i > 0) {
                $(this).replaceWith(`<span class="slide-nav__link store-select">${storeText}</span>`);
                // $(this).replaceWith(`<span class="slide-nav__link store-select">${storeText}</span><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path></svg>`);

                // if (!$(this).find('svg').length) {
                // $(this).append(`<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path></svg>`);
                // }
            }
        });

        // $('#FooterMobileNav .slide-nav__dropdown[data-parent="tier-2-store-pickup1"] li a').each(function (i) {
        //     const storeText = $(this).find('span').text();

        //     console.log('span text: ', storeText);

        //     if (i > 0) {
        //         $(this).replaceWith(`<span class="slide-nav__link store-select">${storeText}</span>`);
        //         // $(this).replaceWith(`<span class="slide-nav__link store-select">${storeText}</span><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path></svg>`);

        //         // if (!$(this).find('svg').length) {
        //         // $(this).append(`<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path></svg>`);
        //         // }
        //     }
        // });

        // $('#HeaderWrapper .site-nav .site-nav__item:nth-child(2) a').replaceWith(`<span class="site-nav__link site-nav__link--underline store-select">Delivery</span>`);

        $('#HeaderWrapper .site-nav .site-nav__item:first-child .site-nav__dropdown-list li').on('click', function (e) {
            e.preventDefault();

            let store = $(this).text().replace(/\s/g, "");

            if (store === 'AppleValley') {
                store = 'Apple Valley';
            } else if (store === 'EdenPrairie') {
                store = 'Eden Prairie';
            } else if (store === 'MapleGrove') {
                store = 'Maple Grove';
            } else if (store === 'PriorLake') {
                store = 'Prior Lake';
            }

            localStorage.setItem('locksmithStore', store);

            let data = {
                attributes: {
                    'locksmith': ''
                }
            }

            fetch('/cart/update.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            })
                .then(response => response.json())
                .then(data => {
                    Cookies.remove('locksmith-params');
                    window.location.href = '/collections/all';
                });
        });

        $('#MobileNav .slide-nav__dropdown[data-parent="tier-2-store-pickup1"] li').on('click', function (e) {
            e.preventDefault();

            let store = $(this).text().replace(/\s/g, "");

            if (store === 'AppleValley') {
                store = 'Apple Valley';
            } else if (store === 'EdenPrairie') {
                store = 'Eden Prairie';
            } else if (store === 'MapleGrove') {
                store = 'Maple Grove';
            } else if (store === 'PriorLake') {
                store = 'Prior Lake';
            }

            localStorage.setItem('locksmithStore', store);

            let data = {
                attributes: {
                    'locksmith': ''
                }
            }

            fetch('/cart/update.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            })
                .then(response => response.json())
                .then(data => {
                    Cookies.remove('locksmith-params');
                    window.location.href = '/collections/all';
                });
        });

        // $('#FooterMobileNav .slide-nav__dropdown[data-parent="tier-2-store-pickup1"] li').on('click', function (e) {
        //     e.preventDefault();

        //     let store = $(this).text().replace(/\s/g, "");

        //     if (store === 'AppleValley') {
        //         store = 'Apple Valley';
        //     } else if (store === 'EdenPrairie') {
        //         store = 'Eden Prairie';
        //     } else if (store === 'MapleGrove') {
        //         store = 'Maple Grove';
        //     } else if (store === 'PriorLake') {
        //         store = 'Prior Lake';
        //     }

        //     localStorage.setItem('locksmithStore', store);

        //     let data = {
        //         attributes: {
        //             'locksmith': ''
        //         }
        //     }

        //     fetch('/cart/update.js', {
        //         method: 'POST',
        //         credentials: 'same-origin',
        //         headers: {
        //             'Content-Type': 'application/json',
        //         },
        //         body: JSON.stringify(data)
        //     })
        //         .then(response => response.json())
        //         .then(data => {
        //             Cookies.remove('locksmith-params');
        //             window.location.href = '/collections/all';
        //         });
        // });

        // $('#HeaderWrapper .site-nav .site-nav__item:nth-child(2)').on('click', function (e) {
        //     e.preventDefault();

        //     localStorage.setItem('locksmithStore', 'Delivery');

        //     let data = {
        //         attributes: {
        //             'locksmith': ''
        //         }
        //     }

        //     fetch('/cart/update.js', {
        //         method: 'POST',
        //         credentials: 'same-origin',
        //         headers: {
        //             'Content-Type': 'application/json',
        //         },
        //         body: JSON.stringify(data)
        //     })
        //         .then(response => response.json())
        //         .then(data => {
        //             Cookies.remove('locksmith-params');
        //             window.location.href = '/collections/all';
        //         });
        // });
    } catch (err) {
        console.error('caught error in navigationLogic() in custom.js, err: ', err);
    }
}

const setPasscode = () => {
    try {
        const locksmithStore = localStorage.getItem('locksmithStore');
        const locksmithCookie = Cookies.get('locksmith-params');

        if (locksmithStore && !locksmithCookie) {
            Locksmith.submitPasscode(locksmithStore);
        } else if (locksmithCookie && locksmithStore) {
            if ((!locksmithCookie.includes(locksmithStore) && locksmithStore) && !document.location.href.includes('apps/store-locator') &&
                !document.location.href.includes('lets-dish-gift-card')) {
                let data = {
                    attributes: {
                        'locksmith': ''
                    }
                }

                fetch('/cart/update.js', {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(data)
                })
                    .then(response => response.json())
                    .then(data => {
                        Cookies.remove('locksmith-params');
                        window.location.reload()
                    });
            }
        }
    } catch (err) {
        console.error('error caught in setPasscode() in custom.js, err: ', err);
    }
}

// Helper function to extract location name from localStorage or cookie
const getLocationName = () => {
    const locksmithStore = localStorage.getItem('locksmithStore');
    const locksmithCookie = Cookies.get('locksmith-params');
    const knownLocations = ['Apple Valley', 'Eden Prairie', 'Maple Grove', 'Prior Lake', 'Woodbury', 'Delivery'];
    
    // First priority: use localStorage value
    if (locksmithStore !== null && locksmithStore !== '' && knownLocations.includes(locksmithStore)) {
        return locksmithStore;
    }
    
    // Second priority: parse cookie more robustly
    if (locksmithCookie) {
        try {
            // Try to parse as JSON first
            try {
                const parsedCookie = JSON.parse(locksmithCookie);
                if (parsedCookie && typeof parsedCookie === 'object') {
                    const locationName = parsedCookie.location || parsedCookie.store || parsedCookie.name || null;
                    if (locationName && knownLocations.includes(locationName)) {
                        return locationName;
                    }
                }
            } catch (e) {
                // Not JSON, try string parsing
            }
            
            // Try to extract location name from cookie string
            // Look for known location names in the cookie
            for (let location of knownLocations) {
                if (locksmithCookie.includes(location)) {
                    return location;
                }
            }
            
            // If still not found, try the original parsing method as fallback
            if (locksmithCookie.includes(':"')) {
                let formattedCookie = locksmithCookie.split(':"')[1];
                if (formattedCookie && formattedCookie.includes('",')) {
                    formattedCookie = formattedCookie.split('",')[0];
                    // Only use if it matches a known location
                    if (knownLocations.includes(formattedCookie)) {
                        return formattedCookie;
                    }
                }
            }
        } catch (err) {
            console.error('Error parsing locksmith cookie:', err);
        }
    }
    
    return null;
}

const setCollectionsTitle = () => {
    try {
        // Set header text on collections all page
        const currentTitle = $('.section-header.section-header--flush .section-header__title').text().replace(/\s/g, "");
        const locationName = getLocationName();

        if (document.location.href.includes('collections/all') && currentTitle === 'All') {
            // Set the title if we found a valid location name
            if (locationName) {
                $('.section-header.section-header--flush .section-header__title').text(locationName);
            }
        }

        // Add informational verbiage to collections all page
        const locationNameForVerbiage = locationName;
        
        if (locationNameForVerbiage) {
            if (document.location.href.includes('/delivery')) {
                $(deliveryVerbiage).insertAfter('.section-header.section-header--flush');

                // Hide promo banner when delivery is selected
                $('#shopify-section-template--14504374108195__promo-grid').addClass('titan-hide');
            } else if (locationNameForVerbiage === 'Apple Valley' && !document.location.href.includes('/delivery')) {
                $(appleValleyVerbiage).insertAfter('.section-header.section-header--flush');
            } else if (locationNameForVerbiage === 'Eden Prairie' && !document.location.href.includes('/delivery')) {
                $(edenPrairieVerbiage).insertAfter('.section-header.section-header--flush');
            } else if (locationNameForVerbiage === 'Maple Grove' && !document.location.href.includes('/delivery')) {
                $(mapleGroveVerbiage).insertAfter('.section-header.section-header--flush');
            } else if (locationNameForVerbiage === 'Prior Lake' && !document.location.href.includes('/delivery')) {
                $(priorLakeVerbiage).insertAfter('.section-header.section-header--flush');
            } else if (locationNameForVerbiage === 'Woodbury' && !document.location.href.includes('/delivery')) {
                $(woodburyVerbiage).insertAfter('.section-header.section-header--flush');
            }
        } else {
            if (document.location.href.includes('/delivery')) {
                $(deliveryVerbiage).insertAfter('.section-header.section-header--flush');

                // Hide promo banner when delivery is selected
                $('#shopify-section-template--14504374108195__promo-grid').addClass('titan-hide');
            }
        }
    } catch (err) {
        console.error('error caught in setCollectionsTitle() in custom.js, err: ', err);
    }
}

const identifyUrlQueryParam = () => {
    if (document.location.href.includes('?store=')) {
        let urlStore = document.location.href.split('?store=')[1];

        if (urlStore === 'AppleValley') {
            urlStore = 'Apple Valley';
        } else if (urlStore === 'EdenPrairie') {
            urlStore = 'Eden Prairie';
        } else if (urlStore === 'MapleGrove') {
            urlStore = 'Maple Grove';
        } else if (urlStore === 'PriorLake') {
            urlStore = 'Prior Lake';
        }

        localStorage.setItem('locksmithStore', urlStore);

        let data = {
            attributes: {
                'locksmith': ''
            }
        }

        fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        })
            .then(response => response.json())
            .then(data => {
                Cookies.remove('locksmith-params');
                window.location.href = '/collections/all';
            });
    }
}

const variantInventory = async () => {
    try {
        const variantStockWrapper = $('.inventoryWrapper.titan-hide p');

        if (variantStockWrapper.length && document.location.href.includes('products/')) {
            const variantStock = parseInt($(variantStockWrapper).text());

            console.log('variantStock: ', variantStock);

            if (variantStock <= 2) {
                $('.payment-buttons button').attr('disabled', 'disabled');
                $('.payment-buttons button').text('Sold Out');

                $('.variant-input').on('click', async function (e) {
                    // e.preventDefault();

                    await delay(200);

                    $('.payment-buttons button').attr('disabled', 'disabled');
                });
            }
        }

        // else if (variantStockWrapper.length && $('.template-collection').length) {
        //     $('.grid-product').each(function () {
        //         const gridVariantWrapper = $(this).find('.inventoryWrapper.titan-hide p');

        //         if (gridVariantWrapper.length) {
        //             const gridVariantPrice = parseInt($(gridVariantWrapper).text());

        //             if (gridVariantPrice <= 2) {
        //                 $(this).find('.grid-product__tags').addClass('grid-product__tag--sold-out');
        //                 $(this).find('.grid-product__tags').text('Sold Out');
        //             }
        //         }
        //     });
        // }
    } catch (err) {
        console.error('error caught in variantInventory() in custom.js, err: ', err);
    }
}

const continueShopping = () => {
    $('.continue__shopping').on('click', function (e) {
        e.preventDefault();

        const currentUrl = document.location.href;
        const referrer = document.referrer;
        
        // Check if user is in the delivery collection
        const isInDeliveryCollection = currentUrl.includes('/collections/delivery') || 
                                       referrer.includes('/collections/delivery');
        
        if (isInDeliveryCollection) {
            // Keep them in the delivery collection
            document.location.href = 'https://letsdish.com/collections/delivery';
        } else {
            // Default: go to the 'all' collection
            document.location.href = 'https://letsdish.com/collections/all';
        }
    });
}

// const locksmithFormListener = () => {
//     console.log('ran locksmithFormListener');

//     $('#locksmith-content #locksmith_passcode').change(function (e) {
//         console.log('e.target.value: ', e.target.value);
//     });
// }

const clearLocksmithCookie = () => {
    try {
        const cookiesCleared = localStorage.getItem('cookiesCleared');

        if (!document.referrer.includes('letsdish') && !document.location.href.includes('store=')) {
            if (!cookiesCleared) {
                localStorage.setItem('cookiesCleared', true);
                localStorage.removeItem('locksmithStore');

                let data = {
                    attributes: {
                        'locksmith': ''
                    }
                }

                fetch('/cart/update.js', {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(data)
                })
                    .then(response => response.json())
                    .then(data => {
                        Cookies.remove('locksmith-params');
                        window.location.reload()
                    });
            } else {
                localStorage.removeItem('cookiesCleared');
            }
        }
    } catch (err) {
        console.error('error caught in clearLocksmithCookie() in custom.js, err: ', err);
    }
}

const storeLocatorPage = () => {
    try {
        const locksmithCookie = Cookies.get('locksmith-params');
        const locksmithStore = localStorage.getItem('locksmithStore');

        if (document.location.href.includes('apps/store-locator') && !locksmithCookie) {
            Locksmith.submitPasscode('Apple Valley');
        }
    } catch (err) {
        console.error('error caught in storeLocatorPage() in custom.js, err: ', err);
    }
}

const aboutUsMobile = () => {
    try {
        const linkHtml = `<li class="slide-nav__item about-us-mobile"><a href="https://letsdish.com/pages/about-us" class="slide-nav__link">
                    <span>View About Us</span>
                    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path></svg>
                  </a></li>`;

        if (!$('#MobileNav .slide-nav__item.about-us-mobile').length) {
            $(linkHtml).insertAfter('#MobileNav .slide-nav > .slide-nav__item:last-child .slide-nav__dropdown > .slide-nav__item:first-child');
        }
    } catch (err) {
        console.error('error caught in aboutUsMobile() in custom.js, err: ', err);
    }
}

// Runs on DOMReady, runs on each page load
document.addEventListener("DOMContentLoaded", async function () {
    try {
        let i = 0;

        while (!window.$) {
            await delay(100);
            i++;
        }

        // Sets Locksmith cookie programmatically if user has used nav to select store or delivery
        // This is to solve for a user selecting a store or delivery and then also having to fill out the Locksmith form
        setPasscode();

        // All store location links and delivery links go to collections/all page, Locksmith handles what products are shown to user
        // This function sets page title from 'All' to the selected store or delivery
        setCollectionsTitle();

        // Changes links to span tags so we can manually redirect after logic
        // Workaround so a user doesn't have to select a store from nav AND also fill out Locksmith form
        navigationLogic();

        // Fix duplicate contact us form that I couldn't figure out where it's coming from
        aboutUsPage();

        // Look for url query param and set Locksmith cookie accordingly
        identifyUrlQueryParam();

        // Reference hidden variant stock element to show out of stock button instead of add to cart where applicable
        // variantInventory();

        // Continue Shopping button logic (cart drawer)
        continueShopping();

        // Store locksmith passcode when default form is used
        // locksmithFormListener();

        // Clears Locksmith cookie if user visits site in new tab, window or session
        clearLocksmithCookie();

        // Workaround to unlock apps/store-locator page
        storeLocatorPage();

        // Add 'About Us' link to mobile nav
        aboutUsMobile();
    } catch (err) {
        console.error('error caught in custom.js domready, error: ', err);
    }
});